import { putActiveOrganization } from "@/api/meApi";
import { queryClient } from "@/lib/queryClient";

/**
 * Persist the active org on the server, then hard-reload the SPA.
 * Org switch is a full tenant context change — soft cache clears are not enough.
 */
export async function switchActiveOrganization(organizationId: string): Promise<void> {
  await putActiveOrganization(organizationId);
  queryClient.clear();
  window.location.assign("/");
}
